export default __webpack_public_path__ + "static/media/not-evaluations-icon.1f26baf0.svg";